import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../../lib';


const formName = 'Reception Signs';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Wall-type': '',
  'Size-area': '',
  'Content': '',
  'Type': '',
  'Thickness': '',
  'Material': '',
  'Installation-required': '',
};

const fields = [
  'Quantity',
  'Size',
  'Wall-type',
  'Size-area',
  'Content',
  'Type',
  'Thickness',
  'Material',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Wall-type'
        inputTextName='Wall-type'
        register={register}
        formState={formState}
        label='Type of wall'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Size-area'
        inputTextName='Size-area'
        register={register}
        formState={formState}
        label='Size of area'
        theme={inputTheme}
      />

      <Textarea
        textareaId='Content'
        textareaName='Content'
        register={register}
        formState={formState}
        label='Content'
        theme={textareaTheme}
      />

      <Radio
        radioId='Type'
        radioName='Type'
        legend='Type of sign?'
        options={[
          { value: '3D', label: '3D' },
          { value: 'rigid', label: 'Rigid' },
          { value: 'suspended', label: 'Suspended' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Thickness'
        inputTextName='Thickness'
        register={register}
        formState={formState}
        label='If a 3D sign, desired thickness'
        theme={inputTheme}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='If a 3D sign, desired material'
        options={[
          { value: 'acrylic', label: 'Acrylic' },
          { value: 'metal', label: 'Metal' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Installation required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
